<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- Sicherer Default: der unkritische "Abbrechen/Weiter bearbeiten"-Button
       bekommt den initialen Fokus, nicht die destruktive Aktion. -->
  <button mat-stroked-button [mat-dialog-close]="false" cdkFocusInitial>
    {{ data.cancelText }}
  </button>
  <button
    mat-raised-button
    class="confirm-dialog__confirm"
    [class.confirm-dialog__confirm--danger]="data.danger"
    [mat-dialog-close]="true">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
